document.addEventListener('turbo:load', () => {
  const run = document.getElementsByClassName('component video-card');

  const wistiaPlayer = (code) => {
    if (!window.Wistia || typeof Wistia.api !== 'function') {
      return null;
    }

    return Wistia.api(code);
  };

  const playVideo = (code, attempts = 0) => {
    const player = wistiaPlayer(code);

    if (!player) {
      if (attempts < 20) {
        setTimeout(() => playVideo(code, attempts + 1), 100);
      }

      return;
    }

    player.time(4);
    player.play();
  };

  const pauseVideo = (code) => {
    const player = wistiaPlayer(code);

    if (player) {
      player.pause();
    }
  };

  const closeModal = (modal) => {
    pauseVideo(modal.dataset.videoModalCode);

    if (modal.open && typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }

    modal.classList.add('hidden');

    if (document.querySelectorAll('dialog.component.video-card-modal[open]').length === 0) {
      document.body.classList.remove('overflow-y-hidden');
    }
  };

  const openModal = (id, code) => {
    const modal = document.querySelector(`#${id}-modal`);
    const video = document.querySelector(`#${id}`);
    const modalPlayer = modal.querySelector('[data-video-modal-player]');

    document.body.appendChild(modal);
    modalPlayer.appendChild(video);
    modal.classList.remove('hidden');
    document.body.classList.add('overflow-y-hidden');
    video.classList.remove('hidden');

    if (!modal.open && typeof modal.showModal === 'function') {
      try {
        modal.showModal();
      } catch (_error) {
        modal.setAttribute('open', '');
      }
    } else if (!modal.open) {
      modal.setAttribute('open', '');
    }

    requestAnimationFrame(() => {
      playVideo(code);
    });
  };

  const playInline = (videoCard, id, code) => {
    videoCard.querySelectorAll('.details').forEach((detail) => {
      detail.classList.add('hidden');
    });

    const video = document.querySelector(`#${id}`);
    videoCard.appendChild(video);
    videoCard.classList.remove('flex');
    videoCard.classList.remove('p-4');
    video.classList.remove('hidden');
    playVideo(code);
  };

  if (run.length > 0) {
    const videoCards = document.querySelectorAll('.component.video-card');

    videoCards.forEach((videoCard) => {
      if (videoCard.dataset.videoCardBound === 'true') {
        return;
      }

      videoCard.dataset.videoCardBound = 'true';

      const openInModal = videoCard.dataset.openInModal === 'true';

      videoCard.addEventListener('click', () => {
        const id = videoCard.dataset.id;
        const code = videoCard.dataset.video;

        if (openInModal) {
          openModal(id, code);
        } else {
          playInline(videoCard, id, code);
        }
      }, openInModal ? undefined : { once: true });
    });
  }

  document.querySelectorAll('[data-video-modal-close]').forEach((closeButton) => {
    if (closeButton.dataset.videoModalCloseBound === 'true') {
      return;
    }

    closeButton.dataset.videoModalCloseBound = 'true';
    closeButton.addEventListener('click', () => {
      closeModal(closeButton.closest('.component.video-card-modal'));
    });
  });

  document.querySelectorAll('.component.video-card-modal').forEach((modal) => {
    if (modal.dataset.videoModalBound === 'true') {
      return;
    }

    modal.dataset.videoModalBound = 'true';

    modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal(modal);
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal(modal);
      }
    });
  });
});
